// A backslash, or an ASCII control character (below 0x20, or DEL).
const isUnsafeChar = (c) => c === '\\' || c.charCodeAt(0) < 0x20 || c.charCodeAt(0) === 0x7f;

/**
 * Where someone may be sent back to after the sign-in round trip: a same-site
 * path that is not an auth page. Null for anything else.
 *
 * `//host` is a protocol-relative URL, which a browser reads as another site,
 * so it is refused rather than repaired. So is a value holding a backslash or
 * an ASCII control character anywhere: browsers read `\` as `/` and strip tabs
 * and newlines before parsing, so `/\evil.com` and `/<tab>/evil.com` are
 * `//evil.com` to them. The backend's `session_service.safe_return_to` refuses
 * the same values. The auth pages are refused because returning to one after
 * signing in would either loop or land the person on a page meant for
 * signed-out visitors.
 *
 * Shared by `AuthContext.login()`, before Google, `SignupPage`, after the
 * account exists, and `AuthContext.logout()`, so they can never disagree about
 * what is safe.
 */
export function safeReturnTo(target) {
  if (typeof target !== 'string' || !target.startsWith('/') || target.startsWith('//')) {
    return null;
  }
  if ([...target].some(isUnsafeChar)) return null;
  const isAuthPage = target.startsWith('/login') || target.startsWith('/signup')
    || target.startsWith('/callback');
  return isAuthPage ? null : target;
}
